import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CallbackPage } from './pages/callback/callback.page';
import { TabsPage } from './pages/tabs/tabs.page';
import { HomePage } from './pages/home/home.page';
import { ProfilePage } from './pages/profile/profile.page';
import { SendPage } from './pages/send/send.page';
import { MySendsPage } from './pages/my-sends/my-sends.page';
import { MyCarriesPage } from './pages/my-carries/my-carries.page';
import { CarryPage } from './pages/carry/carry.page';
import { SendUpsertPage } from './pages/send-upsert/send-upsert.page';
import { AuthGuard } from './services/auth/guard.service';
import { RouteDetailPage } from './pages/route-detail/route-detail.page';
import { CarryUpsertPage } from './pages/carry-upsert/carry-upsert.page';
import { FindCarryPage } from './pages/find-carry/find-carry.page';
import { FindSendPage } from './pages/find-send/find-send.page';
import { CarryDetailPage } from './pages/route-found/carry-detail/carry-detail.page';
import { CompanyGuard } from './services/profile/guard-company.service';
import { ChatPage } from './pages/chat/chat.page';
import { SendDetailPage } from './pages/route-found/send-detail/send-detail.page';
import { IdentityCardPage } from './pages/identity-card/identity-card.page';
import { IbanPage } from './pages/iban/iban.page';
import { PaymentSummaryPage } from './pages/payment-summary/payment-summary.page';
import { ThankYouPage } from './pages/thankyou/thankyou.page';
import { MapPage } from './pages/map/map.page';
import { ThankYouSubscriptionPage } from './pages/thankyou-subscription/thankyou-subscription.page';
import { CarryPageGuard } from './services/profile/guard-carry-page.service';
import { NotificationsPage } from './pages/notifications/notifications.page';
import { PaymentErrorPage } from './pages/payment-error/payment-error.page';
import { VerifyEmailPage } from './pages/verify-email/verify-email.page';
import { DeadlinesPage } from './pages/deadlines/deadlines.page';
import { VisuraPage } from './pages/visura/visura.page';
import { StartPage } from './pages/onboarding/start/start.page';
import { TutorialPage } from './pages/onboarding/tutorial/tutorial.page';
import { OnboardingStartGuard } from './services/onboarding/guard-onboarding-start.service';
import { DurcPage } from './pages/durc/durc.page';
import { TruckDetailPage } from './pages/trucks/truck-detail/truck-detail.page';
import { AddTruckPage } from './pages/trucks/add-truck/add-truck.page';
import { TruckDataPage } from './pages/trucks/truck-data/truck-data.page';
import { OnboardingTutorialGuard } from './services/onboarding/guard-onboarding-tutorial.service';
import { DiscoverSendPage } from './pages/discover-send/discover-send.page';
import * as JsonDe from '../assets/i18n/it.json';
import * as JsonEn from '../assets/i18n/en.json';
import * as JsonFr from '../assets/i18n/fr.json';
import * as JsonIs from '../assets/i18n/is.json';
import * as JsonIt from '../assets/i18n/it.json';
import * as JsonRo from '../assets/i18n/ro.json';
import * as JsonPl from '../assets/i18n/ro.json';
import { ChatAIPage } from './pages/chat-ai/chat-ai.page';
import { SendObjectsPage } from './pages/send/send-objects/send-objects.page';

const routes: Routes = [
  {
    path: 'tabs',
    component: TabsPage,
    children: [
      {
        path: 'home',
        component: HomePage,
        data: {
          title: {
            de: `${JsonDe.WEB_PAGE_TITLE.HOME}`,
            it: `${JsonIt.WEB_PAGE_TITLE.HOME}`,
            en: `${JsonEn.WEB_PAGE_TITLE.HOME}`,
            fr: `${JsonFr.WEB_PAGE_TITLE.HOME}`,
            is: `${JsonIs.WEB_PAGE_TITLE.HOME}`,
            ro: `${JsonRo.WEB_PAGE_TITLE.HOME}`,
            pl: `${JsonPl.WEB_PAGE_TITLE.HOME}`,
          }
        }
      },
      {
        path: 'send',
        component: SendPage,
        data: {
          title: {
            de: `${JsonDe.WEB_PAGE_TITLE.REQUEST_SHIPMENT}`,
            it: `${JsonIt.WEB_PAGE_TITLE.REQUEST_SHIPMENT}`,
            en: `${JsonEn.WEB_PAGE_TITLE.REQUEST_SHIPMENT}`,
            fr: `${JsonFr.WEB_PAGE_TITLE.REQUEST_SHIPMENT}`,
            is: `${JsonIs.WEB_PAGE_TITLE.REQUEST_SHIPMENT}`,
            ro: `${JsonRo.WEB_PAGE_TITLE.REQUEST_SHIPMENT}`,
            pl: `${JsonPl.WEB_PAGE_TITLE.REQUEST_SHIPMENT}`,
          }
        }
      },
      {
        path: 'my-sends',
        component: MySendsPage,
        canActivate: [AuthGuard],
        data: {
          title: {
            de: `${JsonDe.WEB_PAGE_TITLE.REQUESTED_SHIPMENTS}`,
            it: `${JsonIt.WEB_PAGE_TITLE.REQUESTED_SHIPMENTS}`,
            en: `${JsonEn.WEB_PAGE_TITLE.REQUESTED_SHIPMENTS}`,
            fr: `${JsonFr.WEB_PAGE_TITLE.REQUESTED_SHIPMENTS}`,
            is: `${JsonIs.WEB_PAGE_TITLE.REQUESTED_SHIPMENTS}`,
            ro: `${JsonRo.WEB_PAGE_TITLE.REQUESTED_SHIPMENTS}`,
            pl: `${JsonPl.WEB_PAGE_TITLE.REQUESTED_SHIPMENTS}`,
          }
        }
      },
      {
        path: 'discover-send',
        component: DiscoverSendPage,
        canActivate: [CarryPageGuard],
        data: {
          title: {
            de: `${JsonDe.WEB_PAGE_TITLE.OFFER_TRANSPORT}`,
            it: `${JsonIt.WEB_PAGE_TITLE.OFFER_TRANSPORT}`,
            en: `${JsonEn.WEB_PAGE_TITLE.OFFER_TRANSPORT}`,
            fr: `${JsonFr.WEB_PAGE_TITLE.OFFER_TRANSPORT}`,
            is: `${JsonIs.WEB_PAGE_TITLE.OFFER_TRANSPORT}`,
            ro: `${JsonRo.WEB_PAGE_TITLE.OFFER_TRANSPORT}`,
            pl: `${JsonPl.WEB_PAGE_TITLE.OFFER_TRANSPORT}`,
          }
        }
      },
      {
        path: 'my-carries',
        component: MyCarriesPage,
        canActivate: [CompanyGuard],
        data: {
          title: {
            de: `${JsonDe.WEB_PAGE_TITLE.OFFERED_TRANSPORTS}`,
            it: `${JsonIt.WEB_PAGE_TITLE.OFFERED_TRANSPORTS}`,
            en: `${JsonEn.WEB_PAGE_TITLE.OFFERED_TRANSPORTS}`,
            fr: `${JsonFr.WEB_PAGE_TITLE.OFFERED_TRANSPORTS}`,
            is: `${JsonIs.WEB_PAGE_TITLE.OFFERED_TRANSPORTS}`,
            ro: `${JsonRo.WEB_PAGE_TITLE.OFFERED_TRANSPORTS}`,
            pl: `${JsonPl.WEB_PAGE_TITLE.OFFERED_TRANSPORTS}`,
          }
        }
      },
      {
        path: '',
        redirectTo: '/tabs/home',
        pathMatch: 'full'
      },
    ]
  },
  {
    path: 'callback',
    component: CallbackPage,
    data: {
      title: {
        de: `${JsonDe.WEB_PAGE_TITLE.CALLBACK}`,
        it: `${JsonIt.WEB_PAGE_TITLE.CALLBACK}`,
        en: `${JsonEn.WEB_PAGE_TITLE.CALLBACK}`,
        fr: `${JsonFr.WEB_PAGE_TITLE.CALLBACK}`,
        is: `${JsonIs.WEB_PAGE_TITLE.CALLBACK}`,
        ro: `${JsonRo.WEB_PAGE_TITLE.CALLBACK}`,
        pl: `${JsonPl.WEB_PAGE_TITLE.CALLBACK}`,
      }
    }
  },
  {
    path: 'carry',
    component: CarryPage,
    canActivate: [CarryPageGuard],
    data: {
      title: {
        de: `${JsonDe.WEB_PAGE_TITLE.OFFER_TRANSPORT}`,
        it: `${JsonIt.WEB_PAGE_TITLE.OFFER_TRANSPORT}`,
        en: `${JsonEn.WEB_PAGE_TITLE.OFFER_TRANSPORT}`,
        fr: `${JsonFr.WEB_PAGE_TITLE.OFFER_TRANSPORT}`,
        is: `${JsonIs.WEB_PAGE_TITLE.OFFER_TRANSPORT}`,
        ro: `${JsonRo.WEB_PAGE_TITLE.OFFER_TRANSPORT}`,
        pl: `${JsonPl.WEB_PAGE_TITLE.OFFER_TRANSPORT}`,
      }
    }
  },
  {
    path: 'profile',
    component: ProfilePage,
    canActivate: [AuthGuard],
    data: {
      title: {
        de: `${JsonDe.WEB_PAGE_TITLE.PROFILE}`,
        it: `${JsonIt.WEB_PAGE_TITLE.PROFILE}`,
        en: `${JsonEn.WEB_PAGE_TITLE.PROFILE}`,
        fr: `${JsonFr.WEB_PAGE_TITLE.PROFILE}`,
        is: `${JsonIs.WEB_PAGE_TITLE.PROFILE}`,
        ro: `${JsonRo.WEB_PAGE_TITLE.PROFILE}`,
        pl: `${JsonPl.WEB_PAGE_TITLE.PROFILE}`,
      }
    }
  },
  {
    path: 'send-upsert',
    component: SendUpsertPage,
    canActivate: [AuthGuard],
    data: {
      title: {
        de: `${JsonDe.WEB_PAGE_TITLE.CREATE_SHIPMENT}`,
        it: `${JsonIt.WEB_PAGE_TITLE.CREATE_SHIPMENT}`,
        en: `${JsonEn.WEB_PAGE_TITLE.CREATE_SHIPMENT}`,
        fr: `${JsonFr.WEB_PAGE_TITLE.CREATE_SHIPMENT}`,
        is: `${JsonIs.WEB_PAGE_TITLE.CREATE_SHIPMENT}`,
        ro: `${JsonRo.WEB_PAGE_TITLE.CREATE_SHIPMENT}`,
        pl: `${JsonPl.WEB_PAGE_TITLE.CREATE_SHIPMENT}`,
      }
    }
  },
  {
    path: 'send-upsert/:id',
    component: SendUpsertPage,
    canActivate: [AuthGuard],
    data: {
      title: {
        de: `${JsonDe.WEB_PAGE_TITLE.EDIT_SHIPMENT}`,
        it: `${JsonIt.WEB_PAGE_TITLE.EDIT_SHIPMENT}`,
        en: `${JsonEn.WEB_PAGE_TITLE.EDIT_SHIPMENT}`,
        fr: `${JsonFr.WEB_PAGE_TITLE.EDIT_SHIPMENT}`,
        is: `${JsonIs.WEB_PAGE_TITLE.EDIT_SHIPMENT}`,
        ro: `${JsonRo.WEB_PAGE_TITLE.EDIT_SHIPMENT}`,
        pl: `${JsonPl.WEB_PAGE_TITLE.EDIT_SHIPMENT}`,
      }
    }
  },
  {
    path: 'carry-upsert',
    component: CarryUpsertPage,
    canActivate: [CompanyGuard],
    data: {
      title: {
        de: `${JsonDe.WEB_PAGE_TITLE.CREATE_TRANSPORT}`,
        it: `${JsonIt.WEB_PAGE_TITLE.CREATE_TRANSPORT}`,
        en: `${JsonEn.WEB_PAGE_TITLE.CREATE_TRANSPORT}`,
        fr: `${JsonFr.WEB_PAGE_TITLE.CREATE_TRANSPORT}`,
        is: `${JsonIs.WEB_PAGE_TITLE.CREATE_TRANSPORT}`,
        ro: `${JsonRo.WEB_PAGE_TITLE.CREATE_TRANSPORT}`,
        pl: `${JsonPl.WEB_PAGE_TITLE.CREATE_TRANSPORT}`,
      }
    }
  },
  {
    path: 'carry-upsert/:id',
    component: CarryUpsertPage,
    canActivate: [CompanyGuard],
    data: {
      title: {
        de: `${JsonDe.WEB_PAGE_TITLE.EDIT_TRANSPORT}`,
        it: `${JsonIt.WEB_PAGE_TITLE.EDIT_TRANSPORT}`,
        en: `${JsonEn.WEB_PAGE_TITLE.EDIT_TRANSPORT}`,
        fr: `${JsonFr.WEB_PAGE_TITLE.EDIT_TRANSPORT}`,
        is: `${JsonIs.WEB_PAGE_TITLE.EDIT_TRANSPORT}`,
        ro: `${JsonRo.WEB_PAGE_TITLE.EDIT_TRANSPORT}`,
        pl: `${JsonPl.WEB_PAGE_TITLE.EDIT_TRANSPORT}`,
      }
    }
  },
  {
    path: 'route-detail/:id',
    component: RouteDetailPage,
    canActivate: [AuthGuard],
    data: {
      title: {
        de: `${JsonDe.WEB_PAGE_TITLE.NEGOTIATION_DETAIL}`,
        it: `${JsonIt.WEB_PAGE_TITLE.NEGOTIATION_DETAIL}`,
        en: `${JsonEn.WEB_PAGE_TITLE.NEGOTIATION_DETAIL}`,
        fr: `${JsonFr.WEB_PAGE_TITLE.NEGOTIATION_DETAIL}`,
        is: `${JsonIs.WEB_PAGE_TITLE.NEGOTIATION_DETAIL}`,
        ro: `${JsonRo.WEB_PAGE_TITLE.NEGOTIATION_DETAIL}`,
        pl: `${JsonPl.WEB_PAGE_TITLE.NEGOTIATION_DETAIL}`,
      }
    }
  },
  {
    path: 'carry-detail',
    component: CarryDetailPage,
    data: {
      title: {
        de: `${JsonDe.WEB_PAGE_TITLE.TRANSPORT_DETAIL_FOUNDED}`,
        it: `${JsonIt.WEB_PAGE_TITLE.TRANSPORT_DETAIL_FOUNDED}`,
        en: `${JsonEn.WEB_PAGE_TITLE.TRANSPORT_DETAIL_FOUNDED}`,
        fr: `${JsonFr.WEB_PAGE_TITLE.TRANSPORT_DETAIL_FOUNDED}`,
        is: `${JsonIs.WEB_PAGE_TITLE.TRANSPORT_DETAIL_FOUNDED}`,
        ro: `${JsonRo.WEB_PAGE_TITLE.TRANSPORT_DETAIL_FOUNDED}`,
        pl: `${JsonPl.WEB_PAGE_TITLE.TRANSPORT_DETAIL_FOUNDED}`,
      }
    }
  },
  {
    path: 'send-detail',
    component: SendDetailPage,
    data: {
      title: {
        de: `${JsonDe.WEB_PAGE_TITLE.SHIPMENT_DETAIL_FOUNDED}`,
        it: `${JsonIt.WEB_PAGE_TITLE.SHIPMENT_DETAIL_FOUNDED}`,
        en: `${JsonEn.WEB_PAGE_TITLE.SHIPMENT_DETAIL_FOUNDED}`,
        fr: `${JsonFr.WEB_PAGE_TITLE.SHIPMENT_DETAIL_FOUNDED}`,
        is: `${JsonIs.WEB_PAGE_TITLE.SHIPMENT_DETAIL_FOUNDED}`,
        ro: `${JsonRo.WEB_PAGE_TITLE.SHIPMENT_DETAIL_FOUNDED}`,
        pl: `${JsonPl.WEB_PAGE_TITLE.SHIPMENT_DETAIL_FOUNDED}`,
      }
    }
  },
  {
    path: 'send-detail/:routeId',
    component: SendDetailPage,
    data: {
      title: {
        de: `${JsonDe.WEB_PAGE_TITLE.SHIPMENT_DETAIL_FOUNDED}`,
        it: `${JsonIt.WEB_PAGE_TITLE.SHIPMENT_DETAIL_FOUNDED}`,
        en: `${JsonEn.WEB_PAGE_TITLE.SHIPMENT_DETAIL_FOUNDED}`,
        fr: `${JsonFr.WEB_PAGE_TITLE.SHIPMENT_DETAIL_FOUNDED}`,
        is: `${JsonIs.WEB_PAGE_TITLE.SHIPMENT_DETAIL_FOUNDED}`,
        ro: `${JsonRo.WEB_PAGE_TITLE.SHIPMENT_DETAIL_FOUNDED}`,
        pl: `${JsonPl.WEB_PAGE_TITLE.SHIPMENT_DETAIL_FOUNDED}`,
      }
    }
  },
  {
    path: 'find-carry',
    component: FindCarryPage,
    data: {
      title: {
        de: `${JsonDe.WEB_PAGE_TITLE.SEARCH_FOR_TRANSPORT}`,
        it: `${JsonIt.WEB_PAGE_TITLE.SEARCH_FOR_TRANSPORT}`,
        en: `${JsonEn.WEB_PAGE_TITLE.SEARCH_FOR_TRANSPORT}`,
        fr: `${JsonFr.WEB_PAGE_TITLE.SEARCH_FOR_TRANSPORT}`,
        is: `${JsonIs.WEB_PAGE_TITLE.SEARCH_FOR_TRANSPORT}`,
        ro: `${JsonRo.WEB_PAGE_TITLE.SEARCH_FOR_TRANSPORT}`,
        pl: `${JsonPl.WEB_PAGE_TITLE.SEARCH_FOR_TRANSPORT}`,
      }
    }
  },
  {
    path: 'find-send',
    component: FindSendPage,
    data: {
      title: {
        de: `${JsonDe.WEB_PAGE_TITLE.SEARCH_FOR_SHIPMENTS}`,
        it: `${JsonIt.WEB_PAGE_TITLE.SEARCH_FOR_SHIPMENTS}`,
        en: `${JsonEn.WEB_PAGE_TITLE.SEARCH_FOR_SHIPMENTS}`,
        fr: `${JsonFr.WEB_PAGE_TITLE.SEARCH_FOR_SHIPMENTS}`,
        is: `${JsonIs.WEB_PAGE_TITLE.SEARCH_FOR_SHIPMENTS}`,
        ro: `${JsonRo.WEB_PAGE_TITLE.SEARCH_FOR_SHIPMENTS}`,
        pl: `${JsonPl.WEB_PAGE_TITLE.SEARCH_FOR_SHIPMENTS}`,
      }
    }
  },
  {
    path: 'chat/:travelId',
    component: ChatPage,
    canActivate: [AuthGuard],
    data: {
      title: {
        de: `${JsonDe.WEB_PAGE_TITLE.CHAT}`,
        it: `${JsonIt.WEB_PAGE_TITLE.CHAT}`,
        en: `${JsonEn.WEB_PAGE_TITLE.CHAT}`,
        fr: `${JsonFr.WEB_PAGE_TITLE.CHAT}`,
        is: `${JsonIs.WEB_PAGE_TITLE.CHAT}`,
        ro: `${JsonRo.WEB_PAGE_TITLE.CHAT}`,
        pl: `${JsonPl.WEB_PAGE_TITLE.CHAT}`,
      }
    }
  },
  {
    path: 'identity-card',
    component: IdentityCardPage,
    canActivate: [AuthGuard],
    data: {
      title: {
        de: `${JsonDe.WEB_PAGE_TITLE.IDENTITY_CARD}`,
        it: `${JsonIt.WEB_PAGE_TITLE.IDENTITY_CARD}`,
        en: `${JsonEn.WEB_PAGE_TITLE.IDENTITY_CARD}`,
        fr: `${JsonFr.WEB_PAGE_TITLE.IDENTITY_CARD}`,
        is: `${JsonIs.WEB_PAGE_TITLE.IDENTITY_CARD}`,
        ro: `${JsonRo.WEB_PAGE_TITLE.IDENTITY_CARD}`,
        pl: `${JsonPl.WEB_PAGE_TITLE.IDENTITY_CARD}`,
      }
    }
  },
  {
    path: 'visura',
    component: VisuraPage,
    canActivate: [AuthGuard],
    data: {
      title: {
        de: `${JsonDe.WEB_PAGE_TITLE.COMPANY_REGISTRATION}`,
        it: `${JsonIt.WEB_PAGE_TITLE.COMPANY_REGISTRATION}`,
        en: `${JsonEn.WEB_PAGE_TITLE.COMPANY_REGISTRATION}`,
        fr: `${JsonFr.WEB_PAGE_TITLE.COMPANY_REGISTRATION}`,
        is: `${JsonIs.WEB_PAGE_TITLE.COMPANY_REGISTRATION}`,
        ro: `${JsonRo.WEB_PAGE_TITLE.COMPANY_REGISTRATION}`,
        pl: `${JsonPl.WEB_PAGE_TITLE.COMPANY_REGISTRATION}`,
      }
    }
  },
  {
    path: 'iban',
    component: IbanPage,
    canActivate: [AuthGuard],
    data: {
      title: {
        de: `${JsonDe.WEB_PAGE_TITLE.IBAN}`,
        it: `${JsonIt.WEB_PAGE_TITLE.IBAN}`,
        en: `${JsonEn.WEB_PAGE_TITLE.IBAN}`,
        fr: `${JsonFr.WEB_PAGE_TITLE.IBAN}`,
        is: `${JsonIs.WEB_PAGE_TITLE.IBAN}`,
        ro: `${JsonRo.WEB_PAGE_TITLE.IBAN}`,
        pl: `${JsonPl.WEB_PAGE_TITLE.IBAN}`,
      }
    }
  },
  {
    path: 'deadlines',
    component: DeadlinesPage,
    canActivate: [AuthGuard],
    data: {
      title: {
        de: `${JsonDe.WEB_PAGE_TITLE.DEADLINES}`,
        it: `${JsonIt.WEB_PAGE_TITLE.DEADLINES}`,
        en: `${JsonEn.WEB_PAGE_TITLE.DEADLINES}`,
        fr: `${JsonFr.WEB_PAGE_TITLE.DEADLINES}`,
        is: `${JsonIs.WEB_PAGE_TITLE.DEADLINES}`,
        ro: `${JsonRo.WEB_PAGE_TITLE.DEADLINES}`,
        pl: `${JsonPl.WEB_PAGE_TITLE.DEADLINES}`,
      }
    }
  },
  {
    path: 'payment-summary/:travelId',
    component: PaymentSummaryPage,
    canActivate: [AuthGuard],
    data: {
      title: {
        de: `${JsonDe.WEB_PAGE_TITLE.PAYMENT_SUMMARY}`,
        it: `${JsonIt.WEB_PAGE_TITLE.PAYMENT_SUMMARY}`,
        en: `${JsonEn.WEB_PAGE_TITLE.PAYMENT_SUMMARY}`,
        fr: `${JsonFr.WEB_PAGE_TITLE.PAYMENT_SUMMARY}`,
        is: `${JsonIs.WEB_PAGE_TITLE.PAYMENT_SUMMARY}`,
        ro: `${JsonRo.WEB_PAGE_TITLE.PAYMENT_SUMMARY}`,
        pl: `${JsonPl.WEB_PAGE_TITLE.PAYMENT_SUMMARY}`,
      }
    }
  },
  {
    path: 'thankyou',
    component: ThankYouPage,
    data: {
      title: {
        de: `${JsonDe.WEB_PAGE_TITLE.THANK_YOU_PAGE}`,
        it: `${JsonIt.WEB_PAGE_TITLE.THANK_YOU_PAGE}`,
        en: `${JsonEn.WEB_PAGE_TITLE.THANK_YOU_PAGE}`,
        fr: `${JsonFr.WEB_PAGE_TITLE.THANK_YOU_PAGE}`,
        is: `${JsonIs.WEB_PAGE_TITLE.THANK_YOU_PAGE}`,
        ro: `${JsonRo.WEB_PAGE_TITLE.THANK_YOU_PAGE}`,
        pl: `${JsonPl.WEB_PAGE_TITLE.THANK_YOU_PAGE}`,
      }
    }
  },
  {
    path: 'payment-error',
    component: PaymentErrorPage,
    data: {
      title: {
        de: `${JsonDe.WEB_PAGE_TITLE.PAYMENT_ERROR}`,
        it: `${JsonIt.WEB_PAGE_TITLE.PAYMENT_ERROR}`,
        en: `${JsonEn.WEB_PAGE_TITLE.PAYMENT_ERROR}`,
        fr: `${JsonFr.WEB_PAGE_TITLE.PAYMENT_ERROR}`,
        is: `${JsonIs.WEB_PAGE_TITLE.PAYMENT_ERROR}`,
        ro: `${JsonRo.WEB_PAGE_TITLE.PAYMENT_ERROR}`,
        pl: `${JsonPl.WEB_PAGE_TITLE.PAYMENT_ERROR}`,
      }
    }
  },
  {
    path: 'thankyou-subscription',
    component: ThankYouSubscriptionPage,
    data: {
      title: {
        de: `${JsonDe.WEB_PAGE_TITLE.THANK_YOU_PAGE_SUBSCRIPTION}`,
        it: `${JsonIt.WEB_PAGE_TITLE.THANK_YOU_PAGE_SUBSCRIPTION}`,
        en: `${JsonEn.WEB_PAGE_TITLE.THANK_YOU_PAGE_SUBSCRIPTION}`,
        fr: `${JsonFr.WEB_PAGE_TITLE.THANK_YOU_PAGE_SUBSCRIPTION}`,
        is: `${JsonIs.WEB_PAGE_TITLE.THANK_YOU_PAGE_SUBSCRIPTION}`,
        ro: `${JsonRo.WEB_PAGE_TITLE.THANK_YOU_PAGE_SUBSCRIPTION}`,
        pl: `${JsonPl.WEB_PAGE_TITLE.THANK_YOU_PAGE_SUBSCRIPTION}`,
      }
    }
  },
  {
    path: 'map/:travelId',
    component: MapPage,
    canActivate: [AuthGuard],
    data: {
      title: {
        de: `${JsonDe.WEB_PAGE_TITLE.PACKAGE_TRACKING}`,
        it: `${JsonIt.WEB_PAGE_TITLE.PACKAGE_TRACKING}`,
        en: `${JsonEn.WEB_PAGE_TITLE.PACKAGE_TRACKING}`,
        fr: `${JsonFr.WEB_PAGE_TITLE.PACKAGE_TRACKING}`,
        is: `${JsonIs.WEB_PAGE_TITLE.PACKAGE_TRACKING}`,
        ro: `${JsonRo.WEB_PAGE_TITLE.PACKAGE_TRACKING}`,
        pl: `${JsonPl.WEB_PAGE_TITLE.PACKAGE_TRACKING}`,
      }
    }
  },
  {
    path: 'notifications',
    component: NotificationsPage,
    canActivate: [AuthGuard],
    data: {
      title: {
        de: `${JsonDe.WEB_PAGE_TITLE.NOTIFICATIONS_HISTORY}`,
        it: `${JsonIt.WEB_PAGE_TITLE.NOTIFICATIONS_HISTORY}`,
        en: `${JsonEn.WEB_PAGE_TITLE.NOTIFICATIONS_HISTORY}`,
        fr: `${JsonFr.WEB_PAGE_TITLE.NOTIFICATIONS_HISTORY}`,
        is: `${JsonIs.WEB_PAGE_TITLE.NOTIFICATIONS_HISTORY}`,
        ro: `${JsonRo.WEB_PAGE_TITLE.NOTIFICATIONS_HISTORY}`,
        pl: `${JsonPl.WEB_PAGE_TITLE.NOTIFICATIONS_HISTORY}`,
      }
    }
  },
  {
    path: 'verify-email',
    component: VerifyEmailPage,
    data: {
      title: {
        de: `${JsonDe.WEB_PAGE_TITLE.CHECK_EMAIL}`,
        it: `${JsonIt.WEB_PAGE_TITLE.CHECK_EMAIL}`,
        en: `${JsonEn.WEB_PAGE_TITLE.CHECK_EMAIL}`,
        fr: `${JsonFr.WEB_PAGE_TITLE.CHECK_EMAIL}`,
        is: `${JsonIs.WEB_PAGE_TITLE.CHECK_EMAIL}`,
        ro: `${JsonRo.WEB_PAGE_TITLE.CHECK_EMAIL}`,
        pl: `${JsonPl.WEB_PAGE_TITLE.CHECK_EMAIL}`,
      }
    }
  },
  {
    path: 'onboarding/start',
    component: StartPage,
    canActivate: [OnboardingStartGuard],
    data: {
      title: {
        de: `${JsonDe.WEB_PAGE_TITLE.START}`,
        it: `${JsonIt.WEB_PAGE_TITLE.START}`,
        en: `${JsonEn.WEB_PAGE_TITLE.START}`,
        fr: `${JsonFr.WEB_PAGE_TITLE.START}`,
        is: `${JsonIs.WEB_PAGE_TITLE.START}`,
        ro: `${JsonRo.WEB_PAGE_TITLE.START}`,
        pl: `${JsonPl.WEB_PAGE_TITLE.START}`,
      }
    }
  },
  {
    path: 'onboarding/tutorial',
    component: TutorialPage,
    canActivate: [OnboardingTutorialGuard],
    data: {
      title: {
        de: `${JsonDe.WEB_PAGE_TITLE.SIGN_UP_ONBOARDING_1}`,
        it: `${JsonIt.WEB_PAGE_TITLE.SIGN_UP_ONBOARDING_1}`,
        en: `${JsonEn.WEB_PAGE_TITLE.SIGN_UP_ONBOARDING_1}`,
        fr: `${JsonFr.WEB_PAGE_TITLE.SIGN_UP_ONBOARDING_1}`,
        is: `${JsonIs.WEB_PAGE_TITLE.SIGN_UP_ONBOARDING_1}`,
        ro: `${JsonRo.WEB_PAGE_TITLE.SIGN_UP_ONBOARDING_1}`,
        pl: `${JsonPl.WEB_PAGE_TITLE.SIGN_UP_ONBOARDING_1}`,
      }
    }
  },
  {
    path: 'durc',
    component: DurcPage,
    data: {
      title: {
        de: `${JsonDe.WEB_PAGE_TITLE.DURC}`,
        it: `${JsonIt.WEB_PAGE_TITLE.DURC}`,
        en: `${JsonEn.WEB_PAGE_TITLE.DURC}`,
        fr: `${JsonFr.WEB_PAGE_TITLE.DURC}`,
        is: `${JsonIs.WEB_PAGE_TITLE.DURC}`,
        ro: `${JsonRo.WEB_PAGE_TITLE.DURC}`,
        pl: `${JsonPl.WEB_PAGE_TITLE.DURC}`,
      }
    }
  },
  {
    path: 'trucks/truck-detail',
    component: TruckDetailPage,
    data: {
      title: {
        de: `${JsonDe.WEB_PAGE_TITLE.VEHICLE_DETAIL}`,
        it: `${JsonIt.WEB_PAGE_TITLE.VEHICLE_DETAIL}`,
        en: `${JsonEn.WEB_PAGE_TITLE.VEHICLE_DETAIL}`,
        fr: `${JsonFr.WEB_PAGE_TITLE.VEHICLE_DETAIL}`,
        is: `${JsonIs.WEB_PAGE_TITLE.VEHICLE_DETAIL}`,
        ro: `${JsonRo.WEB_PAGE_TITLE.VEHICLE_DETAIL}`,
        pl: `${JsonPl.WEB_PAGE_TITLE.VEHICLE_DETAIL}`,
      }
    }
  },
  {
    path: 'trucks/add-truck',
    component: AddTruckPage,
    data: {
      title: {
        de: `${JsonDe.WEB_PAGE_TITLE.VEHICLE_DETAIL_INSERT_NUMBER_PLATE}`,
        it: `${JsonIt.WEB_PAGE_TITLE.VEHICLE_DETAIL_INSERT_NUMBER_PLATE}`,
        en: `${JsonEn.WEB_PAGE_TITLE.VEHICLE_DETAIL_INSERT_NUMBER_PLATE}`,
        fr: `${JsonFr.WEB_PAGE_TITLE.VEHICLE_DETAIL_INSERT_NUMBER_PLATE}`,
        is: `${JsonIs.WEB_PAGE_TITLE.VEHICLE_DETAIL_INSERT_NUMBER_PLATE}`,
        ro: `${JsonRo.WEB_PAGE_TITLE.VEHICLE_DETAIL_INSERT_NUMBER_PLATE}`,
        pl: `${JsonPl.WEB_PAGE_TITLE.VEHICLE_DETAIL_INSERT_NUMBER_PLATE}`,
      }
    }
  },
  {
    path: 'trucks/truck-data',
    component: TruckDataPage,
    data: {
      title: {
        de: `${JsonDe.WEB_PAGE_TITLE.VEHICLE_DETAIL_INSERT_DATA}`,
        it: `${JsonIt.WEB_PAGE_TITLE.VEHICLE_DETAIL_INSERT_DATA}`,
        en: `${JsonEn.WEB_PAGE_TITLE.VEHICLE_DETAIL_INSERT_DATA}`,
        fr: `${JsonFr.WEB_PAGE_TITLE.VEHICLE_DETAIL_INSERT_DATA}`,
        is: `${JsonIs.WEB_PAGE_TITLE.VEHICLE_DETAIL_INSERT_DATA}`,
        ro: `${JsonRo.WEB_PAGE_TITLE.VEHICLE_DETAIL_INSERT_DATA}`,
        pl: `${JsonPl.WEB_PAGE_TITLE.VEHICLE_DETAIL_INSERT_DATA}`,
      }
    }
  },
  {
    path: 'chat-ai',
    component: ChatAIPage,
    data: {
      title: {
        de: `${JsonDe.WEB_PAGE_TITLE.CHAT}`,
        it: `${JsonIt.WEB_PAGE_TITLE.CHAT}`,
        en: `${JsonEn.WEB_PAGE_TITLE.CHAT}`,
        fr: `${JsonFr.WEB_PAGE_TITLE.CHAT}`,
        is: `${JsonIs.WEB_PAGE_TITLE.CHAT}`,
        ro: `${JsonRo.WEB_PAGE_TITLE.CHAT}`,
        pl: `${JsonPl.WEB_PAGE_TITLE.CHAT}`,
      }
    }
  },
  {
    path: 'send-objects',
    component: SendObjectsPage,
    data: {
      title: {
        de: `send_objects`,
        it: `send_objects`,
        en: `send_objects`,
        fr: `send_objects`,
        is: `send_objects`,
        ro: `send_objects`,
        pl: `send_objects`,
      }
    }
  },
  
  {
    path: '',
    redirectTo: '/onboarding/start',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: '/onboarding/start',
    pathMatch: 'full',
  },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
